import { i18n } from '@/locales';
const lc = 'views.store_delivery_possible_area.';
export const searchResultTableHeader = [
    {
        title: i18n.t(`${lc}si_gun_gu`),
        width: 224,
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}eup_myeon_dong_ri`),
        width: 224,
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}add_area`),
        width: 141,
        align: 'center',
        sortable: false,
    },
];
export const storeDeliveryPossibleAreaTable = [
    {
        title: i18n.t(`${lc}si_do`),
        width: 153,
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}si_gun_gu`),
        width: 153,
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}eup_myeon_dong_ri`),
        width: 153,
        align: 'start',
        sortable: false,
    },
    {
        title: i18n.t(`${lc}remove_area`),
        width: 141,
        align: 'center',
        sortable: false,
    },
];
export const gaiaConstantGroupType = {
    SI_DO: 'SI_DO',
    SI_GUN_GU: 'SI_GUN_GU',
    EUP_MYEON_DONG: 'EUP_MYEON_DONG',
};
